import React from 'react';
import PropTypes from 'prop-types';
import * as endpoints from '../../constants/ApiEndpoints';
import { getCsrfToken } from '../../helpers/BrowserUtils';

import MobileMenuToggle from '../MobileMenuToggle/MobileMenuToggleContainer';

const UserSettingsPanel = ({ logout, showLogoutButton }) => {
  return (
    <div className="user-settings-panel flex flex-column" data-qa="UserSettingsPanel">
      <div className="panel-title">
        <MobileMenuToggle />
        <h1>Settings</h1>
      </div>
      <div className="panel-content">
        {
          showLogoutButton &&
              <form action={endpoints.LOGOUT} method="post">
                <input type="hidden" name="_csrf" value={getCsrfToken(window)} />
                <button className="btn outline" id="logout-button" type="submit">Logout</button>
              </form>
        }
      </div>
    </div>
  );
};

UserSettingsPanel.propTypes = {
  logout: PropTypes.func.isRequired,
};

export default UserSettingsPanel;
